import { InvoiceDTO } from '../domain/models';

export class JsonInvoiceService {
  export(invoice: InvoiceDTO, downloadFileName?: string) {
    const blob = new Blob([JSON.stringify(invoice, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = downloadFileName || `invoice-${invoice.invoiceNumber || ''}.json`;
    a.click();
    URL.revokeObjectURL(url);
  }

  async import(file: File): Promise<InvoiceDTO> {
    const text = await file.text();
    return JSON.parse(text) as InvoiceDTO;
  }
}
